import React, { useState, useEffect } from 'react';
import './TwoColumnFeatureBanner.scss';

const InfoIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 29.5303L18.67 20.7603H15.625V18.2603H21.6275L21.7025 27.0303H24.5V29.5303H18.75ZM18.125 14.0253C18.1071 13.496 18.2923 12.9799 18.6425 12.5828C18.985 12.2003 19.4775 12.0103 20.1175 12.0103C20.7575 12.0103 21.2525 12.2003 21.6025 12.5853C21.9525 12.9653 22.125 13.4478 22.125 14.0253C22.125 14.5953 21.95 15.0678 21.6 15.4453C21.25 15.8203 20.7575 16.0103 20.1175 16.0103C19.4775 16.0103 18.985 15.8228 18.6425 15.4453C18.2932 15.0564 18.1078 14.5476 18.125 14.0253ZM20 33.2603C23.3152 33.2603 26.4946 31.9433 28.8388 29.5991C31.183 27.2549 32.5 24.0755 32.5 20.7603C32.5 17.445 31.183 14.2656 28.8388 11.9214C26.4946 9.57721 23.3152 8.26025 20 8.26025C16.6848 8.26025 13.5054 9.57721 11.1612 11.9214C8.81696 14.2656 7.5 17.445 7.5 20.7603C7.5 24.0755 8.81696 27.2549 11.1612 29.5991C13.5054 31.9433 16.6848 33.2603 20 33.2603ZM20 35.7603C18.0302 35.7603 16.0796 35.3723 14.2597 34.6184C12.4399 33.8646 10.7863 32.7597 9.3934 31.3669C8.00052 29.974 6.89563 28.3204 6.14181 26.5005C5.38799 24.6806 5 22.7301 5 20.7603C5 18.7904 5.38799 16.8399 6.14181 15.02C6.89563 13.2001 8.00052 11.5465 9.3934 10.1537C10.7863 8.76077 12.4399 7.65588 14.2597 6.90206C16.0796 6.14824 18.0302 5.76025 20 5.76025C23.9782 5.76025 27.7936 7.34061 30.6066 10.1537C33.4196 12.9667 35 16.782 35 20.7603C35 24.7385 33.4196 28.5538 30.6066 31.3669C27.7936 34.1799 23.9782 35.7603 20 35.7603Z"
      fill="#666666"
    />
  </svg>
);

const TwoColumnFeatureBanner = (props) => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const questions =
    props?.fields?.FeatureQnABlock?.map((qna, index) => ({
      id: index + 1,
      text: qna.fields?.Question?.value,
      tooltip: qna.fields?.Answer?.value,
    })) || [];

  const handleTooltipToggle = (id, event) => {
    event.stopPropagation();
    setActiveTooltip(activeTooltip === id ? null : id);
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && !!window) {
      const handleClickAway = () => {
        setActiveTooltip(null);
      };

      window.addEventListener('click', handleClickAway);

      return () => {
        window.removeEventListener('click', handleClickAway);
      };
    }
  }, []);

  const bannerGifSrc = `${props?.fields?.BannerMedia?.value?.src}`;
  const bannerGifMobileSrc = `${props?.fields?.BannerMediaMobile?.value?.src}`;
  const title = props?.fields?.Title?.value;
  const headline = props?.fields?.Headline?.value;
  const subHeadline = props?.fields?.SubHeadline?.value;
  const alexaImageSrc = `${props?.fields?.SectionImage?.value?.src}`;

  return (
    <div className="banner">
      <div className="column first-panel" data-aos="fade-up">
        <h2 className="title">{title}</h2>
        <h3 className="headline">{headline}</h3>
        <p className="subheadline">{subHeadline}</p>
        <div className="question-list">
          {questions.map((question) => (
            <div key={question.id} className="question">
              <span className="question-text">{`${question.id}. ${question.text}`}</span>
              <button
                onClick={(event) => handleTooltipToggle(question.id, event)}
                className="info-button"
                aria-label="More information"
              >
                <InfoIcon />
              </button>
              {activeTooltip === question.id && (
                <div className="popupbox">
                  <p>{question.tooltip}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        <img src={alexaImageSrc} alt="Alexa" className="alexa-image" loading="lazy" />
      </div>
      <div className="column second-panel" data-aos="fade-up">
        <picture>
          <source media="(max-width: 768px)" srcSet={bannerGifMobileSrc} />
          <img className="banner-image" src={bannerGifSrc} alt="Banner" loading="lazy" />
        </picture>
      </div>
    </div>
  );
};

export default React.memo(TwoColumnFeatureBanner);
